import { useEffect } from 'react';
import { useRouter } from 'next/router';
import { VAS, VasViewEvents } from 'src/common/utils/segment/types';
import { initialiseAckoAnalytics } from 'src/common/utils/globals/initialiseAckoAnalytics';
import useStorage from 'src/common/custom-hooks';
import MobileV2F from 'src/vas/components/application/mobile';
import DesktopV2F from 'src/vas/components/application/desktop';
import { useViewport } from 'src/common/utils/responsive';
import { FlexContainer } from 'src/common/styles';
import { sendVasEvents } from 'src/common/utils/segment';

const Index = () => {
  const router = useRouter();
  const query = router?.query;
  const { isMobile } = useViewport();
  const { setItem } = useStorage();

  useEffect(() => {
    initialiseAckoAnalytics();
    setItem(VAS.VAS_ROUTER_QUERY, JSON.stringify(query as any), 'session');
    setItem(VAS.VAS_RESUME_BOOKING_REFERER, '', 'session');
    setItem(VAS.VAS_MY_BOOKING_REFERER, '', 'session');
    setItem(VAS.VAS_HISTORY_REFERER, '', 'session');
    sendVasEvents(
      VasViewEvents.VIEW_PAGE_VISA_ASSISTANCE_COUNTRY_SELECTION_PAGE
    );
  }, []);

  return (
    <>
      {isMobile ? (
        <FlexContainer>
          <MobileV2F />
        </FlexContainer>
      ) : (
        <DesktopV2F />
      )}
    </>
  );
};

export default Index;
